var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.createSchedule()}}},[_vm._v(_vm._s(_vm.$t('work-schedule.create-schedule')))])])}
var staticRenderFns = []

export { render, staticRenderFns }